export default "__VITE_ASSET__CU5YTsS2__"